import { memo } from "react";
import { Box, Container, Typography, Button } from "@mui/material";
import { Link } from "react-router-dom";
import { FullPaddingWrapper } from "../../Components/FullPaddingWrapper/FullPaddingWrapper";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";

const Careers = memo(() => {
  const handleScrollToNewsletter = () => {
    const element = document.getElementById("newsletter-signup");
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "center" });
      // Focus on the name input after scroll completes
      setTimeout(() => {
        const nameInput = document.getElementById("newsletter-name-input");
        if (nameInput) {
          nameInput.focus();
        }
      }, 800);
    }
  };
  return (
    <Container maxWidth="xl" disableGutters>
      <FullPaddingWrapper>
        {/* Hero Section */}
        <Box
          sx={{
            background: "linear-gradient(135deg, #004B4C 0%, #006668 100%)",
            borderRadius: { xs: "16px", md: "24px" },
            minHeight: { xs: 400, md: 500 },
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            p: { xs: 4, md: 8 },
            mb: { xs: 4, md: 6 },
          }}
        >
          <Box
            sx={{
              width: { xs: 80, md: 120 },
              height: { xs: 80, md: 120 },
              borderRadius: "50%",
              backgroundColor: "rgba(255, 255, 255, 0.1)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mb: 4,
            }}
          >
            <WorkOutlineIcon
              sx={{
                fontSize: { xs: 40, md: 60 },
                color: "#ffffff",
              }}
            />
          </Box>

          <Typography
            variant="h2"
            sx={{
              color: "#ffffff",
              fontWeight: 700,
              fontSize: { xs: "2rem", sm: "2.5rem", md: "3rem" },
              lineHeight: 1.2,
              mb: 2,
            }}
          >
            Join Our Team
          </Typography>

          <Typography
            variant="body1"
            sx={{
              color: "#ffffff",
              fontSize: { xs: "1rem", md: "1.2rem" },
              fontWeight: 300,
              lineHeight: 1.6,
              maxWidth: 600,
              opacity: 0.9,
              mb: 4,
            }}
          >
            We're building the future of homeownership. Join a passionate team
            dedicated to making home management simpler for everyone.
          </Typography>

          <Box
            sx={{
              backgroundColor: "rgba(255, 255, 255, 0.15)",
              borderRadius: "12px",
              px: { xs: 4, md: 6 },
              py: { xs: 2, md: 3 },
              border: "1px solid rgba(255, 255, 255, 0.2)",
            }}
          >
            <Typography
              variant="h6"
              sx={{
                color: "#ffffff",
                fontWeight: 600,
                fontSize: { xs: "1rem", md: "1.25rem" },
              }}
            >
              Coming Soon
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: "#ffffff",
                opacity: 0.8,
                mt: 1,
              }}
            >
              We're preparing exciting opportunities. Check back soon!
            </Typography>
          </Box>
        </Box>

        {/* Info Section */}
        <Box
          sx={{
            py: { xs: 6, md: 10 },
            px: { xs: 2, md: 4 },
            textAlign: "center",
          }}
        >
          <Typography
            variant="h4"
            sx={{
              color: "primary.main",
              fontWeight: 700,
              fontSize: { xs: "1.5rem", md: "2rem" },
              mb: 3,
            }}
          >
            Why Work at SimplerHome?
          </Typography>

          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "1fr", md: "repeat(3, 1fr)" },
              gap: 4,
              mt: 6,
              maxWidth: 1000,
              mx: "auto",
            }}
          >
            {[
              {
                title: "Mission-Driven",
                description:
                  "Help millions of homeowners manage their most valuable investment with ease.",
              },
              {
                title: "Innovative Culture",
                description:
                  "Work with cutting-edge technology and creative minds pushing boundaries.",
              },
              {
                title: "Growth Focused",
                description:
                  "Develop your skills with learning opportunities and career advancement.",
              },
            ].map((item, index) => (
              <Box
                key={index}
                sx={{
                  p: 4,
                  borderRadius: "16px",
                  backgroundColor: "#f8f8f8",
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    color: "primary.main",
                    fontWeight: 600,
                    mb: 2,
                  }}
                >
                  {item.title}
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    color: "#333",
                    lineHeight: 1.6,
                  }}
                >
                  {item.description}
                </Typography>
              </Box>
            ))}
          </Box>

          <Button
            variant="contained"
            color="secondary"
            size="large"
            onClick={handleScrollToNewsletter}
            sx={{
              mt: 8,
              px: { xs: 5, md: 10, lg: 15 },
              py: { xs: 1.5, md: 2, lg: 2.5 },
              fontSize: { xs: "1rem", md: "1.1rem", lg: "1.2rem" },
              fontWeight: 500,
              borderRadius: "8px",
              textTransform: "none",
              color: "#ffffff",
            }}
          >
            Get Notified When We're Hiring
          </Button>
          <Box sx={{ mt: 2 }}>
            <Button
              component={Link}
              to="/contact?topic=careers"
              variant="text"
              sx={{ textTransform: "none", fontSize: "1rem" }}
            >
              Or introduce yourself now
            </Button>
          </Box>
        </Box>
      </FullPaddingWrapper>
    </Container>
  );
});

export default Careers;
